import {EntityLineHeader} from './entity-line-header';

export class Entity {

  id!: EntityKey;
  projectName!: string;
  customerId!: string;
  repOfficeId!: string;
  releaseTypeId!: string;
  associatedQuoteId!: string;
  associatedQuoteRevision!: number;
  associatedOrderId!: string;
  associatedOrderRevision!: number;
  internalNotes!: string;
  estimatedScheduleDate!: Date;
  fobCode!: string;
  orderInfo!: string;
  paymentTermsCode!: string;
  expirationDate!: Date;
  salesRepId!: string;
  outsideSalesRepId!: string;
  sfrPriceBasisDate!: Date;
  iecContactId!: string;
  lastProcessDate!: Date;
  createTimestamp!: Date;
  createUser!: string;
  updateTimestamp!: Date;
  updateUser!: string;
  leadTimeCode!: string;
  salesChannelCode!: string;
  expedite!: boolean;
  useTypeCode!: string;
  priceBasisDate!: Date;
  shipAndHandChargeType!: string;
  shipViaCode!: string;
  partialShipmentAllowed!: boolean;
  requestedShipDate!: Date;
  acceptEarlyDelivery!: boolean;
  advanceNoticeHours!: number;
  repPo!: string;
  repRef!: string;
  deliveryContactName!: string;
  deliveryPhone!: string;
  deliveryContactName2!: string;
  deliveryPhone2!: string;
  deliveryCountryCode!: string;
  markCartons!: string;
  externalNotes!: string;
  marketSegmentCode!: string;
  projectTypeCode!: string;
  specTypeCode!: string;
  totalList!: number;
  netAmount!: number;
  specialCharges!: number;
  totalQuoteAmount!: number;
  multiplier!: number;
  unitQuantity!: number;
  statusCode!: string;
  statusDescription!: string;
  sfrStatus!: string;
  fpaStatus!: string;
  approvalStatus!: string;
  frozen!: boolean;
  updateAllowed!: boolean;
  lines!: EntityLineHeader[];
  opportunityId!: string;
  opportunityRevision!: number;
  overrideShipToAttentionLine!: string;
  overrideShipToAddressLine1!: string;
  overrideShipToAddressLine2!: string;
  overrideShipToAddressLine3!: string;
  overrideShipToCityName!: string;
  overrideShipToStateCode!: string;
  overrideShipToPostalCode!: string;
  overrideShipToCountryCode!: string;
  milestone!: string;
  creditExceptionCode!: string;
  lastConfirmedShipDate!: Date;
  reviewStatus!: string;
  projectNumber!: string;
  releaseNumber!: number;
  taxStatus!: string;
  erpStatus!: string;
  trackingNumber!: string;
  shipVia!: string;
  milestoneDescription!: string;
  iecContactDescription!: string;
  priceProtected!: boolean;
  appEngineerSnBypass!: boolean;
  warrantyRequestNotes!: string;
  skyportServicePresent!: boolean;
  prnField1!: string;
  priceListId!: string;
  extendedWarrantyCode!: string;
  parentId!: EntityKey;
  costFactor!: number;
  shippingHandlingChargeAmount!: number;
  partShippingHandlingChargeAmount!: number;
}

export class EntityKey {
  entityName!: string;
  entityId!: string;
  entityRevision!: number;
}
